import { Tooltip, Typography } from '@mui/material';

interface RejectedReasonProps {
  reason?: Nullable<string>;
}

const RejectedReason = ({ reason }: RejectedReasonProps) => {
  if (!reason) return null;

  const shouldTruncate = reason.length > 60;

  const content = (
    <Typography
      color="error"
      variant="body1"
      sx={
        shouldTruncate
          ? {
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              wordBreak: 'break-word',
            }
          : undefined
      }
    >
      {reason}
    </Typography>
  );

  return shouldTruncate ? <Tooltip title={reason}>{content}</Tooltip> : content;
};

export default RejectedReason;
